import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=bff2ac5e"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"
import style0 from "./Companies.vue?vue&type=style&index=0&id=bff2ac5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports